"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchGroupsButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var FetchGroupsButton = function (state) { return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { primary: true, onClick: function () { return state.setGroupsFetchRequest(true); }, loading: state.groupsLoading, disabled: state.groupsLoading, children: i18n_1.default.getGroups })); };
exports.FetchGroupsButton = FetchGroupsButton;
